import adminApi from "services/admin-api";

export const workspaceSessionService = {
  currentUser: adminApi.currentUser,
};
